import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import Admin from "./Pages/Admin";
import NewPassword from "./Pages/NewPassword"
import Provider from "react-redux/es/components/Provider";
import store, {persistor} from "./redux/store";
import Register from "./Pages/Register";
import { PersistGate } from 'redux-persist/integration/react'

class App extends Component {
  render() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <Router>
                <div>
                  <Route path={'/'} exact component={Home}/>
                  <Route path={'/login/'} component={Login}/>
                  <Route path={'/register/'} component={Register}/>
                    <Route path={'/admin/'} component={Admin}/>
                    <Route path={'/newPassword/:token'} component={NewPassword}/>

                </div>
              </Router>
            </PersistGate>
        </Provider>
    );
  }
}

export default App;

